// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3PMMj","productName":"Table_productName__-8bn3"};